
import { required } from 'vuelidate/lib/validators';
import Vue from 'vue';
import { Validation } from 'vuelidate/vuelidate';

/*
	All known backend login error messages. This section is picked up by vue-i18n. DO NOT REMOVE.

	// Login error messages
	this.$t('All fields must be filled');
	this.$t('Login failed');
	this.$t('Missing permissions');
*/

interface LoginForm {
	username: string;
	password: string;
}

export default Vue.extend({
	data() {
		return {
			loginForm: {
				username: '',
				password: '',
			},
			loginCheckMessage: '',
			show: true,
		} as {
			loginForm: LoginForm;
			loginCheckMessage: string;
			show: boolean;
		};
	},
	props: {
		statusMessage: {
			type: String,
			default: '',
		},
	},

	validations: {
		loginForm: {
			username: {
				required,
			},

			password: {
				required,
			},
		},
	},

	computed: {
		passwordState(): boolean | null {
			const { $error } = this.$v.loginForm.password as Validation;
			return $error ? false : null;
		},
	},

	methods: {
		onSubmit(event: Event): void {
			if (event) {
				event.preventDefault();
			}

			this.$v.loginForm.$touch();

			if (this.$v.loginForm.$anyError) {
				this.loginCheckMessage = 'All fields must be filled';
				return;
			}

			this.loginCheckMessage = '';

			this.$emit('loginEvent', this.loginForm);
		},

		onReset(event: Event): void {
			if (event) {
				event.preventDefault();
			}

			this.loginForm.username = '';
			this.loginForm.password = '';
			this.loginCheckMessage = '';
			this.show = false;
			this.$nextTick(() => {
				this.show = true;
			});
		},

		validateState(validation: Validation): boolean | null {
			const { $dirty, $error }: { $dirty: boolean; $error: boolean } = validation;
			return $dirty ? !$error : null;
		},
	},
});
